<template>
  <div class="h-screen">
    <HeaderBar :title="hTitle" />
    <ul class="list-disc my-4">
      <h2 class="font-bold">{{ subTitle1 }}</h2>
      <CheckList :ulListCheck="items" />
    </ul>
    <ul class="list-disc my-4">
      <h2 class="font-bold">{{ subTitle2 }}</h2>
      <CheckList :ulListCheck="items2" />
    </ul>
    {{ footer }}
  </div>
</template>

<script>
import HeaderBar from "../../components/HeaderBar.vue";
import CheckList from "../../components/CheckList.vue";
export default {
  components: { HeaderBar, CheckList },
  props: ["hTitle"],
  data() {
    return {
      title: "Documentary Requirements",
      subTitle1: "A. Individuals",
      subTitle2: "B. Company",
      items: [
        {
          id: 1,
          li: "Accomplished Buyers Information Sheet signed by both spouses, if applicable",
        },
        {
          id: 2,
          li: "1 valid primary government issued ID (ex. TIN, UMID, Passport, SSS, Driver’s License, Postal ID)",
        },
        {
          id: 3,
          li: "Birth Certificate if single; Marriage Contract if married",
        },
        {
          id: 4,
          li: "BIR 1904 Form Verified by BIR of both spouses, if applicable",
        },
      ],
      items2: [
        { id: 1, li: "Certificate of Incorporation" },
        { id: 2, li: "Certificate of Registration" },
        { id: 3, li: "Secretary Certificate / Board Resolution" },
        { id: 4, li: "Articles of Incorporation and By-Laws" },
        { id: 5, li: "TIN Verified of authorized signatory" },
        { id: 6, li: "2 valid government issued IDs of signatory" },
      ],
      footer:
        "Once you have completed the payments and requirements, you will be contacted to schedule the signing the Deed of Absolute Sale at our head office.",
    };
  },
};
</script>







